import React, {useState, useEffect} from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as TreeFunctions from '../utilities/TreeFunctions';
import * as TypeEvaluation from '../TypeEvaluation';
import Form2 from '../Tabs/Form2';
import NormalBtn from '../StockItems/NormalBtn';
import DropdownMenu from '../StockItems/DropdownMenu';
import { Icon } from '@iconify/react';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var startPath = props.startPath;
  var currentList = props.currentList;
  var error = props.error;
  var organicChanges = props.organicChanges;
  var width = props.width;
  var addToExtraScreen = props.addToExtraScreen;
  var userNos = props.userNos;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var changeTab = props.changeTab;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;
  var chains = props.chains;

  const [pathDown, setPathDown] = useState([]);

  useEffect(()=>{
    var tgt = currentList;
    for (var i = 0; i < startPath.length; i++){
      tgt = tgt[startPath[i]];
      if (!tgt){

        var beforeHere = CoreFns.filterPathDown(startPath, i + 1);
        var out = {};
        var out1 = out;
        for (var j = i + 1; j < startPath.length; j++){
          out1[startPath[j]] = {};
          out1 = out1[startPath[j]];
        }
        out1.t = '';
        var changes = [{t:'w',w:beforeHere,n:out}];
        organicChanges(changes);
        break
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var pieces = [];
  var nos = pathDown.length;

  function clickFollowUpAction(p){
    return function(e){
      setPathDown(p);
    }
  }

  var errorLocString = '';
  if (error){
    errorLocString = error.loc.join(' ');
  }

  for (var i = 0; i < nos + 1; i ++){

    var toThisPt = CoreFns.filterPathDown(pathDown, i);

    function doFollowUpActions(i, treeActions){
      return treeActions.map((anAction, index)=>{

        var color = '#888888';
        if (anAction.i === pathDown[i]){
          color = '#4397a1';
          haveFoundFollowUp = true;
        }else{
          var beyondX = startPath.concat(toThisPt.concat([anAction.i]));
          var beyondString = beyondX.join(' ');
          if (errorLocString.indexOf(beyondString) === 0){
            color = 'red';
          }else if (anAction.i === 'If_Succeed'){
            var beyondX1 = startPath.concat(toThisPt.concat(['trig']));
            var beyondString1 = beyondX1.join(' ');
            if (errorLocString.indexOf(beyondString1) === 0){
              color = 'red';
            }
          }
        }

        var icon = 'charm:menu-hamburger';
        if (anAction.i === 'If_True' || anAction.i === 'If_Confirm'){
          icon = 'icon-park-outline:check';
        }else if (anAction.i === 'If_False' || anAction.i === 'If_Deny'){
          icon = 'icon-park-outline:close';
        }else if (anAction.i === 'next' || anAction.i === 'Post_Prompt' || anAction.i === 'If_Succeed' || anAction.i === 'Post_Change_Value'){
          icon = 'fluent:add-square-24-regular';
        }else if (anAction.i === 'If_Fail' || anAction.i === 'If_Cancel'){
          icon = 'clarity:cancel-line';
        }else{
          console.warn(anAction);
        }

        return <i className='qtip tip-bottom' data-tip={anAction.q}><div style={{color}}> <Icon onClick = {clickFollowUpAction(toThisPt.concat([anAction.i]))} className ='fa' icon={icon} /></div>
        </i>
      })    
    }


    var path = startPath.concat(toThisPt);
    var overallThisClick;
    var gotError = false;
    try{
      overallThisClick = CoreFns.goDownPath(currentList, path);
    }catch(err){
      gotError = true;
    }
    if (gotError){
      break;
    }

    var treeNonActions = [];
    var treeActions = [];
    if (!overallThisClick){
      overallThisClick = {t:''};
    }
    if (overallThisClick){
      var tree = ResponsiveFns.getQuestionsOfACurrentAnswer(currentList, path, overallThisClick, chains, changeTab);
      if (tree){
        treeNonActions = tree.filter((aQn, index)=>{
          return aQn.t.t !== 'Action';
        })
        treeActions = tree.filter((aQn, index)=>{
          return aQn.t.t === 'Action'
        })        
      }
    }

    var buttonOptions = TreeFunctions.actionOptions(currentList, path);

    function clickButton(path){
      return function(actionTxt){
        if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 5){
          setDoingWhat({t:'guide',v:6});
        }

        var overallThisClick2;

        try{
          overallThisClick2 = CoreFns.goDownPath(currentList, path);
        }catch(err){
        } 

        if (!overallThisClick2){
          return;
        }


        var orig = JSON.parse(JSON.stringify(overallThisClick2));

        var action = {t:actionTxt};
        var followUpQuestions = ResponsiveFns.getQuestionsOfACurrentAnswer(currentList, path, action, chains);
        TreeFunctions.iterateThroughQuestionsInside(followUpQuestions, action, action, [], currentList, path, '');
        var action2 = JSON.parse(JSON.stringify(action));
        var actionKeys = Object.keys(action);
        actionKeys.forEach((anActionKey, index)=>{
          if (anActionKey !== 't'){
            if (orig[anActionKey]){
              action2[anActionKey] = orig[anActionKey];
            }
          }
        })
        var changes = [{t:'w',w:path, n:action2}];
        organicChanges(changes);

      }
    }

    var sc = currentList.sc;

  //

    var details = null;
    if (overallThisClick.t.indexOf('existingContractFn') === 0){
      var otherPartsSplit = overallThisClick.t.split(' ');

      var contractInfo = CoreFns.getContractInfo(currentList, otherPartsSplit[1]);
      if (contractInfo){
        var detailsTextListSet = TreeFunctions.getComments(contractInfo, {t:'function', nos:otherPartsSplit[2]});
        if (detailsTextListSet){
          function clickElaborate(e){
            addToExtraScreen({t:'functionDetails', v:detailsTextListSet.textList, title:detailsTextListSet.functionName})
          }
          details = <center><NormalBtn onClick={clickElaborate} title='Details' icon='cil:magnifying-glass' /></center>
  //
        }

      }else{
        details = <center>Placeholder for a function {otherPartsSplit[2]} of a contract</center>
//
      }

    }

    var haveFoundFollowUp = false;
    var followOnActions = doFollowUpActions(i, treeActions);

    var errorLine = null;
    var thisLoc = path.join(' ');
    if (error){ 
      if (errorLocString === thisLoc){
        errorLine = <div style={{color:'red'}}> {error.t} </div>
//
      }
    }else if (i === 0){
      if (overallThisClick.t.indexOf('existingContractFn') === 0){
        var pieces3 = overallThisClick.t.split(' ');
        if (pieces3[2] === 'stake'){
          var stakeLoc = overallThisClick.t.indexOf(' stake ');
          var contractInfoAbi = CoreFns.getContractInfoAbi(currentList, pieces3[1]);
          var beyond = overallThisClick.t.substr(stakeLoc + 1);
          var fnInfo = CoreFns.getAbiFnInfo(contractInfoAbi, beyond, true);          
          if (fnInfo && fnInfo.stateMutability === 'payable'){            
          }else{
            errorLine = <div style={{color:'orange', padding:'5px'}}>Staking functions should be preceded with an increase allowance or approval function from the coin or NFT, unless the token staked is the native currency, in which case this is not necessary. Please click on the ? button on the top right-hand order of this panel for details.</div>
          }
//
        }else if (pieces3[2].indexOf('exchange') === 0){
          var contractInfoAbi4 = CoreFns.getContractInfoAbi(currentList, pieces3[1]);
          var exchangeLoc4 = overallThisClick.t.indexOf(' exchange');
          var fnInfo4 = CoreFns.getAbiFnInfo(contractInfoAbi4, exchangeLoc4, true);          
          if (fnInfo4 && fnInfo4.stateMutability === 'payable'){            
          }else{
            errorLine = <div style={{color:'orange', padding:'5px'}}>Exchange functions should be preceded with an increase allowance or approval function from the coin or NFT, unless the token staked is the native currency, in which case ths is not necessary. Please click on the ? button on the top right-hand order of this panel for details.</div>
          }
//

        }
      }
    }
//
    var triggerPiece = null;
    var lastPathItem = toThisPt[toThisPt.length - 1];
    if (lastPathItem === 'If_Succeed' && overallThisClick && overallThisClick.t !== ''){

      var pathMinus = CoreFns.filterPathDown(path, path.length - 1);
      var prevClick = CoreFns.goDownPath(currentList, path, 1);
      if (prevClick.t.indexOf('existingContractFn ') === 0){
        var clickPieces = prevClick.t.split(' ');
        var tgt = clickPieces[1];
        var Abi = CoreFns.getContractInfoAbi(currentList, tgt);
        if (Abi){
          var trigP = [];
          for (var i21 = 0; i21 < Abi.length; i21++){
            var aAbi = Abi[i21];
            if (aAbi.type === 'event'){
              trigP.push({n:aAbi.name, i:aAbi.name + ' ' + aAbi.inputs.length})
            }            
          }

          function abiEventQuestions(item){
            var inputs = [];
            var itemA = item.split(' ')[0];
            for (var i = 0; i < Abi.length; i++){
              if (Abi[i].name === itemA){
                inputs = Abi[i].inputs;
              }              
            }
            var questionsX = [];
            inputs.forEach((anInput, index)=>{
              if (anInput.indexed){
                var inputType = TypeEvaluation.convertSCTypeToInternalType(anInput);
                questionsX.push({q:'Filter Trigger based on ' + anInput.name, h:'',t:{t:'Conditional', o:[{n:'Yes',h:'', i:'1',c:[{q: anInput.name, t:inputType, i:'v', f:1, c:[]}]},{n:'No',h:'', i:'0',c:[]}]},i:anInput.name,c:[]});
              }
            })
            return questionsX;
          }

          function clickTrig(item){
            var questionsX = abiEventQuestions(item);
            var subs = {};
            TreeFunctions.iterateThroughQuestionsInside(questionsX, subs, subs, [], currentList, pathMinus, '');
            var n = {i:item, subs};
            var changes = [{t:'w',w:pathMinus.concat(['trig']),n}];
            organicChanges(changes);
          }

          var currentTrig = '';
          var questionsBit = null;
          if (prevClick.trig){
            currentTrig = prevClick.trig.i;
            if (currentTrig === 0 || +currentTrig > 0){
              function updateTrig(e){
                var n = Abi[currentTrig].name;
                var changes = [{t:'w',w:pathMinus.concat(['trig', 'i']),n}];
                organicChanges(changes);
              }
              questionsBit = <button onClick={updateTrig}>Update Trig</button>
//
            }else{
              var questionsX = abiEventQuestions(currentTrig);

              questionsBit = <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={questionsX} header={pathMinus.concat(['trig', 'subs'])} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={false} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>

            }
          }

          triggerPiece = <div>
            Trigger<br/>
            <DropdownMenu isSortedAlphabetically={true} clickItemInSelect={clickTrig} options={trigP} currentAnswer={currentTrig}/>
            {questionsBit}
            <br/>
          </div>
//
        }

      }

    }

    if (overallThisClick.t.indexOf('existingContractFn') === 0){
      var pieces1 = overallThisClick.t.split(' ');
      if (pieces1.length === 3){
        function clickUpdate(e){
          var contractInfoAbi = CoreFns.getContractInfoAbi(currentList, pieces1[1]);
          var thisAbiNew = CoreFns.getAbiFnInfo(contractInfoAbi, pieces1[2], true);
          var ph = 'existingContractFn ' + pieces1[1] + ' ' + pieces1[2] + ' ' + thisAbiNew.inputs.length;
          organicChanges([{t:'w',w:path.concat(['t']),n:ph}])
        }
        errorLine = <button onClick={clickUpdate}>Update to new</button>
      }
    }

//

    pieces.push(<div key={i} style={{width:'100%'}}>
      {triggerPiece}
      <DropdownMenu clickItemInSelect={clickButton(path)} options={buttonOptions} currentAnswer={overallThisClick.t}/>
      {errorLine}
      {details}
      <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={treeNonActions} header={path} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={false} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>
      <center>
      {followOnActions}
      </center>
      </div>)

    if (!haveFoundFollowUp){
      break;
    }
  }
//

    var scWarning;
    if (sc){
      var nosSC = Object.keys(sc).length;
      if (nosSC === 0){
        function clickSC(e){
          changeTab('Contracts', 0);
        }
        scWarning = <div><br/>More functions will be available if smart contracts are added. Click <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={clickSC}>[here]</span> to do.</div>
      }      
    }

    var last = startPath[startPath.length - 1];
    var passBit = null;
    if (last === 'click'){
      var funk = [{q:'Pass click through',i:'passT', h:'If yes, a click on this element will propagate to the element (if any) behind this element.', f:0, t:{t:'Boolean'}}];
      passBit = <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={funk} header={startPath} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={false} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>
    }

  return <div style={{width:width*0.9, textAlign:'left', padding:5}}>
      <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'actions'}}/><br/>
    {pieces}
    {scWarning}
    <br/>
    {passBit}
  </div>
}
//


export default App;
